<template>
  <div :class="placeholderClass" class="DigitPlaceHolder-input-placeholder lxn-float-left lxn-border-round lxn-pos-rel lxn-overflow-hidden">
    <div :class="$store.getters.language.font" class="DigitPlaceHolder-input-digit lxn-w100 lxn-text-center lxn-title">
      {{digit}}
    </div>
    <div :class="digitClass" class="DigitPlaceHolder-input-line lxn-w100 lxn-pos-abs">
    </div>
  </div>
</template>

<script>

export default {
  name: 'DigitPlaceHolder',
  components: {
  },
  props: {
    index: Number,
    confirmationCode: String,
    focused: Boolean
  },
  methods: {
  },
  computed: {
    digit: function () {
      return this.focused ? this.confirmationCode.charAt(this.index) : '-';
    },
    digitClass: function () {
      var returnValue = '';
      if(this.focused){
        if(this.confirmationCode.length > this.index){
          returnValue = 'green';
        }else{
          returnValue = 'orange';
        }
      }
      return returnValue;
    },
    placeholderClass: function () {
      var returnValue = '';
      if(this.focused){
        if(this.confirmationCode.length == this.index){
          returnValue = 'selected';
        }else{
          returnValue = 'notSelected';
        }
      }
      return returnValue;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .DigitPlaceHolder-input-placeholder {
    width: calc((100% - 20px)/5);
    height: 50px;
    background-color: #ECECEC;
    margin-right: 5px;
  }
  .DigitPlaceHolder-input-placeholder.selected {
    opacity: 1;
  }
  .DigitPlaceHolder-input-placeholder.notSelected {
    opacity: 0.5;
  }
  .DigitPlaceHolder-input-placeholder:last-child {
    margin-right: 0;
  }
  .DigitPlaceHolder-input-digit {
    height: 45px;
    line-height: 45px;
  }
  .DigitPlaceHolder-input-line {
    bottom: 0;
    left: 0;
    height: 3px;
    background-color: transparent;
  }
  .DigitPlaceHolder-input-line.orange {
    background-color: #F1BC52;
  }
  .DigitPlaceHolder-input-line.green {
    background-color: #3BB878;
  }
</style>
